import React, { useState } from "react";
import { Menu } from "lucide-react";

const DropdownMenu = () => {
    const [isOpen, setIsOpen] = useState(false);

    return (
        <div className="relative">
            <button
                onClick={() => setIsOpen(!isOpen)}
                className="p-2 rounded-full bg-white/80 hover:bg-white shadow-md backdrop-blur transition-all mt-2 relative"
            >
                <Menu className="w-6 h-6 text-primary" />

                {/* 🔵 Circulito pulsante */}
                <span className="absolute top-0 right-0 flex h-2 w-2">
                    <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-secondary opacity-75"></span>
                    <span className="relative inline-flex rounded-full h-2 w-2 bg-secondary"></span>
                </span>
            </button>

            {/* Menú desplegable con 3 opciones */}
            {isOpen && (
                <div className="absolute left-0 mt-3 w-48 bg-white/30 backdrop-blur-md shadow-lg rounded-xl border border-white/20 overflow-hidden animate-fade-in-up">
                    <a
                        href="/about"
                        className="block px-5 py-3 text-primary hover:bg-secondary/20 hover:scale-[1.03] transition-all duration-200 ease-in-out"
                    >
                        About Us
                    </a>
                    <a
                        href="/blog"
                        className="block px-5 py-3 text-primary hover:bg-secondary/20 hover:scale-[1.03] transition-all duration-200 ease-in-out"
                    >
                        Blog
                    </a>
                    <a
                        href="/impact-program"
                        className="block px-5 py-3 text-primary hover:bg-secondary/20 hover:scale-[1.03] transition-all duration-200 ease-in-out"
                    >
                        Slowork Impact
                    </a>
                </div>
            )}
        </div>
    );
};

export default DropdownMenu;
